import * as React from "react";

function IconEnvelope(props) {
  return (
    <svg
      fill="#0099FF"
      viewBox="0 0 16 17"
      height="30px"
      width="30px"
      {...props}
    >
      <path d="M0 4a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H2a2 2 0 01-2-2V4zm2-1a1 1 0 00-1 1v.217l7 4.2 7-4.2V4a1 1 0 00-1-1H2zm13 2.383l-4.708 2.825L15 11.105V5.383zm-.034 6.876l-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 002 13h12a1 1 0 00.966-.741zM1 11.105l4.708-2.897L1 5.383v5.722z" />
    </svg>
  );
}

export default IconEnvelope;